import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../app/app.service';
import { ColourScheme, DealerGroupBrandingV, DealerGroupV, GenericIdName } from '../GET_NEW_UI/setup-implement/setup-implement.model';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dealergroup-branding',
  templateUrl: './dealergroup-branding.component.html',
  styleUrls: ['./dealergroup-branding.component.scss']
})
export class DealergroupBrandingComponent implements OnInit {
  //DealerGroup:GenericIdName[]= [];
  colourSchemes: ColourScheme[] = [];
  selectedColourSchemeId: number;
  selectedDealerGroupId: number;
  loadingData: boolean = false;
  dealergroups: DealerGroupV[];
  imageUrl: string = '';
  ImageFile: File;
  ImageName: string;
  constructor(private appService: AppService, private _notify: NotificationsService,private _sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<DealergroupBrandingComponent>,) { }

  ngOnInit() {

    this.appService.getAllColourSchemes().subscribe(response => {
      this.colourSchemes = response;
      this.loadingData = false;
    });

    this.appService.getAllDealerGroups().subscribe(result => {
      this.dealergroups = result;
    });
  }

  DealerGroupDeatails :DealerGroupBrandingV;
  dealerGroupSelected(dealerGroupId: number) {
    this.appService.GetApplicationStyleForDG(dealerGroupId).subscribe(res => {

      this.DealerGroupDeatails = res;
      if(this.DealerGroupDeatails!=null){
        this.selectedColourSchemeId = this.DealerGroupDeatails.styleId;
if(this.DealerGroupDeatails.Logo!=""){
  this.imageUrl= 'data:image/png;base64,' + this.DealerGroupDeatails.Logo
}else{
  this.imageUrl ='';
}
       
      }else{
        this.selectedColourSchemeId = null;
        this.imageUrl ='';
      }
      
    })
  }

  addNewBrandedStyle() {

    let params: DealerGroupBrandingV = {
      Id: this.selectedDealerGroupId,
      styleId: this.selectedColourSchemeId,
      Logo: this.imageUrl
    }
    this.appService.UpdateDealerGroupBranding(params).subscribe(res => {
      if (res > 0) {
        this._notify.success('Saved', 'Sucessfully update the DealerGroup Branding')
        this.dialogRef.close();
      } else {
        this._notify.error('Error', 'Unable to update the DealerGroup Branding')
      }
    })
  }
  onNoClick() {
    this.dialogRef.close();
  }

  onSelectImage(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url
      this.ImageFile = event.target.files[0];

      reader.onload = (event: any) => { // called once readAsDataURL is completed
        //this.imageUrl = event.target.result;
        this.imageUrl = event.target["result"];
        this.ImageName = this.ImageFile.name;
      }
    }
  }

}
